<template>
    <Layout>
      <EntitlementPersonLayout />

      <section class="p_main">
        <div class="row">
          <div class="col-12 bg-white rounded">
            <h5>Business Employee Information</h5>
            <div class="table-responsive scrollable-table" style="overflow-x: auto">
              <table class="table table-centered table-striped">
                <thead>
                <tr>
                  <th>SL</th>
                  <th>Business Address(Name)</th>
                  <th>Address</th>
                  <th>Work Type</th>
                  <th>Monthly Salary</th>
                  <th>Monthly Work</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(employee_business, index) in employee_businesses" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>Mouza: {{ employee_business.business.structure.land.mouza.mouza_desc }},  Plot: {{ employee_business.business.structure.land.plot_no }}({{ employee_business.business.business_name}})</td>
                  <td>{{ employee_business.address }}</td>
                  <td>{{ employee_business.work_type }}</td>
                  <td>{{ employee_business.salary_month }}</td>
                  <td>{{ employee_business.months_work }}</td>
                </tr>
                </tbody>
              </table>
              <div v-if="flag === false" class="loader">Loading...</div>
              <h5 v-if="employee_businesses.length === 0 && flag === true" class="text-center text-secondary">
                No Data Found
              </h5>
            </div>
          </div>
        </div>
      </section>
    </Layout>
</template>

<script>
    import appConfig from '@src/app.config'
    import Layout from '@layouts/main'
    import PageHeader from '@components/page-header'
    import EntitlementPersonLayout from './layout'
    import http from "@state/http";

    export default {
        page: {
            title: 'Entitlement Person',
            meta: [{ name: 'description', content: appConfig.description }],
        },
        components: { Layout, PageHeader, EntitlementPersonLayout },
        data() {
            return {
                title: 'Entitlement Person Business Employee',
                items: [
                    {
                        text: 'Dashboard',
                        href: '/',
                    },
                    {
                        text: 'Entitlement Person Business Employee',
                        active: true,
                    },
                ],
              employee_businesses: [],
              flag: false
            }
        },
        mounted() {
            this.getEpBusinessEmployee();
        },

        methods: {
          getEpBusinessEmployee() {
                let ses_id = this.$route.params.ses_id;
                http.get("api/entitlement-person/business-employee/list/" + ses_id).then(response => {
                    if (!response.error) {
                      this.flag = true;
                        let data = response.data;
                        this.employee_businesses = data.employee_businesses;
                    }
                });
            }
        },
    }
</script>

<style scoped>
    .scrollable-table {
        overflow-x: auto;
        white-space: nowrap;
    }
</style>